export const match = <Input, Ret, Cond extends Partial<Input> | Input>(value: Input, cond: Array<[Cond, Ret]>, fallback: Ret): Ret => {
  const it = cond.find(([val]) => (val === value || JSON.stringify(val) === JSON.stringify(value)));
  if (!it) return fallback;
  return it[1];
}
